// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"fc58faed","977":"160bf892"}[chunkId] + ".chunk.js";
};